import loadable from '@loadable/component'
export const subNavigationModule = {
  variations: {
    default: loadable(() => import('./index.js'))
  },
  wrapperConfig: { useContainer: true },
  hydrate: false
}
